module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Antecipação","averageRate":"Taxa média (% a.m.)","cost":"Custo antecipação (R$)","viewDetail":"Ver detalhes"},"en-US":{"title":"Prepayment","averageRate":"Average rate (% mo.)","cost":"Prepayment cost (R$)","viewDetail":"View details"}}')
  delete Component.options._Ctor
}
